import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../components/common/InputComp/Input";
import TabComp from "../../../components/TabsComp/TabComp";
import Btn from "../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../utils/asyncStatus";
import { primaryColor } from "../../../utils/themeColors";
import {
  addOMReturnReasonAsync,
  deleteOMReturnReasonAsync,
  editOMReturnReasonAsync,
  getOMReturnReasonAsync,
} from "../../../store/services/orderManagementService";
const ReturnReason = () => {
  const dispatch = useDispatch();
  const {
    getOMReturnReasonStatus,
    getOMReturnReasonError,
    getOMReturnReasonData,
    addOMReturnReasonStatus,
    addOMReturnReasonData,
    addOMReturnReasonError,

    editOMReturnReasonStatus,
    editOMReturnReasonError,
    editOMReturnReasonData,

    deleteOMReturnReasonData,
    deleteOMReturnReasonStatus,
    deleteOMReturnReasonError,
  } = useSelector((state) => state.om);

  useEffect(() => {
    dispatch(getOMReturnReasonAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getOMReturnReasonData?.length
    ? getOMReturnReasonData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedReturnReason, setSelectedReturnReason] = useState();
  const [addReturnReasonMode, setAddReturnReasonMode] = useState(false);
  const [addReturnReasonData, setAddReturnReasonData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedReturnReason", selectedReturnReason);
  // console.log("editData", editData);
  useEffect(() => {
    if (addOMReturnReasonStatus === asyncStatus.SUCCEEDED) {
      setAddReturnReasonMode(false);
      setSaveDisabled(true);
      setAddReturnReasonData();
    }
  }, [, addOMReturnReasonStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteOMReturnReasonAsync(selectedReturnReason?.return_reason_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteOMReturnReasonStatus === asyncStatus.SUCCEEDED || deleteOMReturnReasonStatus === asyncStatus.ERROR ) {
      setOpen(false);
      setSelectedReturnReason();
    }
  }, [, deleteOMReturnReasonStatus]);
  useEffect(() => {
    if (editOMReturnReasonStatus === asyncStatus.SUCCEEDED) {
      setSelectedReturnReason();
      setEditMode(false);
      setEditData()
    }
  }, [, editOMReturnReasonStatus]);

  //   const [tableHeight, setTableHeight] = useState("");
  //   let elem = document.getElementById("containerHeight");
  //   useEffect(() => {
  //     console.log("elem?.offsetHeight",elem?.clientHeight);
  //     setTableHeight(elem?.offsetHeight);
  //   }, [ elem?.offsetHeight]);
  // console.log(containerHeight)
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this return reason?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Return Reason"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Return Reason
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddReturnReasonMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addReturnReasonMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addReturnReasonMode}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddReturnReasonMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addReturnReasonMode || !selectedReturnReason}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addOMReturnReasonStatus === asyncStatus.LOADING ||
                  editOMReturnReasonStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addReturnReasonData) {
                    dispatch(addOMReturnReasonAsync(addReturnReasonData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedReturnReason, ...editData };
                    delete a.id;
                    dispatch(editOMReturnReasonAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={500} width={"100%"}>
              <TableComp
                columns={[
                  { field: "return_reason_id", headerName: "ID", flex: true },
                  { field: "description", headerName: "Return Reason", flex: true },
                ]}
                onRowClick={(e) => {
                  setSelectedReturnReason(e?.row);
                }}
                rows={formattedData}
                loading={
                  getOMReturnReasonStatus === asyncStatus.IDLE ||
                  getOMReturnReasonStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addReturnReasonMode ? (
              <InputWithBtnLayoutComp
              error={addOMReturnReasonError}
                inputArray={[
                  {
                    label: "Return Reason:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddReturnReasonData({
                            ...addReturnReasonData,
                            description: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddReturnReasonData({
                            ...addReturnReasonData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedReturnReason ? (
              <InputWithBtnLayoutComp
              error={editOMReturnReasonError}
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedReturnReason?.return_reason_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "ReturnReason:",
                    comp: (
                      <InputComp
                        key={selectedReturnReason?.return_reason_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            description: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedReturnReason?.description}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={selectedReturnReason?.is_active|| editData?.is_active}
                        disabled={!editMode}
                        // defaultValue={selectedReturnReason?.is_active || editData?.is_active}
                        defaultChecked={selectedReturnReason?.is_active || editData?.is_active}
                        // checked={selectedReturnReason?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (<Stack>
              <Typography>Select any return reason</Typography>
              <Typography color={"red"} fontSize={12}>{getOMReturnReasonError}</Typography>
            </Stack>
            )}
            <Stack my={2}>
              <TabComp
                tabs={[
                  //   {
                  //     name: "Companies",
                  //     content: (
                  //       <Stack height={400} width={"100%"}>
                  //         <TableComp
                  //           columns={[
                  //             {
                  //               field: "companyId",
                  //               headerName: "Company ID",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "companyName",
                  //               headerName: "Company Name",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "action",
                  //               headerName: "Action",
                  //               flex: true,
                  //             },
                  //           ]}
                  //           //   onRowClick={(e) => {
                  //           //     setSelectedReturnReason(e?.row);
                  //           //   }}
                  //           rows={[]}
                  //           //   loading={
                  //           //     getProductStyleStatus === asyncStatus.IDLE ||
                  //           //     getProductStyleStatus === asyncStatus.LOADING
                  //           //   }
                  //         />
                  //       </Stack>
                  //     ),
                  //   },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedReturnReason(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default ReturnReason;
